export default __webpack_public_path__ + "7ffa95e36b9a7ec48e452bf5059493b0.png";